import React from 'react';
import { createRoot } from 'react-dom/client';

const roots = new Map();

document.addEventListener('turbo:before-render', () => {
  roots.forEach((root, el) => {
    root.unmount();
  });
  roots.clear();
});

export function mountOn(id, Component) {
  document.addEventListener('turbo:load', () => {
    const el = document.getElementById(id);
    if (el && !roots.has(el)) {
      const root = createRoot(el);
      root.render(Component);
      roots.set(el, root);
    }
  });
}
